import {
  gtmPushNewsletterSubscription,
  gtmPushNewsletterUnSubscription,
} from 'modules/gtm/modules/sections/newsletter/newsletter';
import storageModule from 'modules/storage';
import {
  checkSubscription,
  subscribeToNewsLetter,
  unsubscribeFromNewsLetter,
} from 'commerce/shop/client';
import { useNewsletterBody } from './useNewsletterBody';

export const useNewsletter = () => {
  return useNewsletterBody({
    storage: storageModule,
    gtm: {
      gtmPushNewsletterSubscription,
      gtmPushNewsletterUnSubscription: gtmPushNewsletterUnSubscription,
    },
    api: {
      subscribeToNewsLetter,
      unsubscribeFromNewsLetter,
      checkSubscription,
    },
  });
};
